import { requestData } from "@/api/api-config";

export interface StartTelehealthVisitRequest {
  eventId: string;
  providerId: string;
  patientId: string;
  /** Patients the provider confirmed agreed to AI scribe. */
  confirmedPatientIds?: string[];
}

export interface StartTelehealthVisitResponse {
  // Null until the Recall webhook creates the Note on bot admission; the
  // scribe store is hydrated off the TELEHEALTH_BOT_STATUS pubsub alert
  // once it lands. Also null when the RECALL module is disabled — the
  // server still returns the meeting link so "Join meeting" works.
  noteId: string | null;
  botId: string | null;
  meetingLink: string;
  // Lazy-created on first audio chunk for ad-hoc bots, so may be absent
  // from the response (see ENG-2491 slice 5).
  noteTranscriptId?: string | null;
}

export interface EndTelehealthVisitResponse {
  status: "ended" | "already_ended";
}

export interface PauseTelehealthVisitResponse {
  status: "paused" | "resumed";
}

export async function startTelehealthVisit(
  body: StartTelehealthVisitRequest,
): Promise<StartTelehealthVisitResponse | null> {
  return requestData<StartTelehealthVisitResponse>(
    "notes/start-telehealth-visit",
    "post",
    { json: body },
  );
}

/** Saves the patients' No and takes any scribe bot out of the visit. */
export async function declineTelehealthScribe(
  eventId: string,
  shownPatientIds: string[],
): Promise<{ declinedPatientIds: string[] } | null> {
  return requestData<{ declinedPatientIds: string[] }>(
    "notes/decline-telehealth-scribe",
    "post",
    { json: { eventId, shownPatientIds } },
    false,
  );
}

export async function endTelehealthVisit(
  noteId: string,
): Promise<EndTelehealthVisitResponse | null> {
  return requestData<EndTelehealthVisitResponse>(
    `notes/${noteId}/end-telehealth-visit`,
    "post",
  );
}

export async function pauseTelehealthVisit(
  noteId: string,
): Promise<PauseTelehealthVisitResponse | null> {
  return requestData<PauseTelehealthVisitResponse>(
    `notes/${noteId}/pause-telehealth-visit`,
    "post",
  );
}

export async function resumeTelehealthVisit(
  noteId: string,
): Promise<PauseTelehealthVisitResponse | null> {
  return requestData<PauseTelehealthVisitResponse>(
    `notes/${noteId}/resume-telehealth-visit`,
    "post",
  );
}
